/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorComparatorLogic extends models.QueryOperatorComparator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorComparatorLogic");
    }

    getFixupPrototypeFunction() { return QueryOperatorComparatorLogic.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorComparatorLogic>): QueryOperatorComparatorLogic {
        let obj = Object.assign(new QueryOperatorComparatorLogic(), model);
        QueryOperatorComparatorLogic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorComparatorLogic>): QueryOperatorComparatorLogic {
        if (!model) return null;
        return QueryOperatorComparatorLogic.newInstance(<QueryOperatorComparatorLogic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorComparatorLogic) {
        if (!obj) return;

        models.QueryOperatorComparatorLogic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorComparatorLogic): boolean {
        if (models.QueryOperatorComparator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorComparatorLogic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of comparison operation
     */
    op: models.ComparisonQueryCondition;

}
